export interface StockFetchErrorDetails {
  isPartialFailure: boolean;
  stocksLoaded: number;
  totalAttempted: number;
  errorType: 'network' | 'rate_limit' | 'api_error' | 'unknown';
}

export const createStockFetchError = (
  message: string,
  stocksLoaded: number = 0,
  totalAttempted: number = 0,
  errorType: StockFetchErrorDetails['errorType'] = 'unknown'
): Error & StockFetchErrorDetails => {
  const error = new Error(message) as Error & StockFetchErrorDetails;
  error.name = 'StockFetchError';
  error.isPartialFailure = stocksLoaded > 0;
  error.stocksLoaded = stocksLoaded;
  error.totalAttempted = totalAttempted;
  error.errorType = errorType;
  return error;
};

export type StockFetchError = Error & StockFetchErrorDetails;

export const isStockFetchError = (error: unknown): error is StockFetchError => {
  return (
    error instanceof Error &&
    error.name === 'StockFetchError' &&
    'stocksLoaded' in error &&
    'errorType' in error
  );
};

export const getErrorSeverity = (error: StockFetchError): 'warning' | 'error' => {
  return error.isPartialFailure ? 'warning' : 'error';
};

export const getErrorDescription = (error: StockFetchError): string => {
  if (error.isPartialFailure) {
    return `Partial success: Loaded ${error.stocksLoaded} stocks, but encountered issues`;
  }

  switch (error.errorType) {
    case 'rate_limit':
      return 'API rate limit exceeded. Please try again later.';
    case 'network':
      return 'Network connectivity issues. Check your internet connection.';
    case 'api_error':
      return 'API service error. The stock data service is experiencing issues.';
    default:
      return error.message;
  }
};
